// @flow
import React from "react";
import styled from "styled-components";

type Item = {
  label: string,
  value: number | string
};

type Props = {
  options: Array<Item>,
  value: ?number | ?string,
  onChange: Item => void
};

const Label = styled.label`
  padding-right: 20px;
  input {
    margin-right: 5px;
  }
`;

export default class RadioButtons extends React.Component<Props> {
  render() {
    const { onChange, value, options, name } = this.props;
    const selectedValue = value ? options.filter(o => o.value === value)[0].value : undefined;

    return options.map(o => (
      <Label key={o.value}>
        <input
          type="radio"
          name={name}
          value="all"
          checked={o.value === selectedValue}
          onChange={() => onChange(o)}
        />
        {o.label}
      </Label>
    ));
  }
}

export type { Item };
